import React, { useContext, useEffect, useState } from 'react';
import { navigate } from '@reach/router';

import Alert from '@material-ui/lab/Alert';
import AuthContext from '../../../services/firebase/AuthContext';
import CreateReferralContent from './CreateReferralContent';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { keyGen } from '../../../services/keygen';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import { timestamp } from '../../../app/data/validate';

import UserChooser from './UserChooser';
import Spacer from '../../../app/common/ui/Spacer';

const CreateReferralPage = () => {
    const db = useContext(FireDataContext);
    const { currentUser: { uid } } = useContext(AuthContext);

    const [referrer, setReferrer] = useState();
    const [organization, setOrganization] = useState();
    const [users, setUsers] = useState();

    useEffect(() => {
        (async () => {
            setUsers(await db.get({
                path: `users`,
                query: {
                    field: 'roles',
                    operator: 'array-contains',
                    value: 'customer'
                },
                context: 'CreateReferralPage'
            }));
        })();
    }, [db]);

    const handleReferrerSelect = user => {
        const { organization: id } = user;

        if (id) {
            db.get({
                path: `organizations/${id}`,
                context: 'CreateReferralPage'
            })
                .then(org => {
                    setOrganization(org);
                    setReferrer(user);
                })
                .catch(error => console.log(error));
        }

    }

    const handleSubmit = ({ courtCase, request }) => {
        (async () => {

            const referrerId = referrer.id;

            const ts = timestamp();

            const newCourtCase = await db.insert({
                path: `organizations/${organization.id}/cases`,
                payload: {
                    ...courtCase,
                    uid: referrerId,
                    ts
                },
                context: 'CreateReferralPage'
            });

            const { id: courtCaseId } = newCourtCase;

            const { client = {}, location = {}, vulnerabilities = [], message = '', dates = '', clientNeeds = '', tariff = 'tier1' } = request;

            const newReferral = await db.insert({
                path: `organizations/${organization.id}/referrals`,
                payload: {
                    bookingReference: `DIY${keyGen(7)}`.toUpperCase(),
                    referralType: 'assessment',
                    courtCaseId,
                    client,
                    location,
                    vulnerabilities,
                    status: 'Submitted',
                    organizationId: organization.id,
                    tariff,
                    uid: referrerId,
                    ts
                },
                context: 'CreateReferralPage'
            });

            const { id: referralId } = newReferral;

            await db.update({
                path: `organizations/${organization.id}/notes/${referralId}`,
                payload: {
                    dates: {
                        text: dates,
                        uid,
                        ts,
                    },
                    clientNeeds: {
                        text: clientNeeds,
                        uid,
                        ts,
                    },
                }
            })

            const rfq = {
                intermediaryId: uid,
                message,
                dates,
                organization: organization.name,
                organizationId: organization.id,
                referralId,
                referralPath: `organizations/${organization.id}/referrals/${referralId}`,
                status: 'new',
                uid: referrerId,
                ts,
            };

            await db.update({
                path: `organizations/${organization.id}/referrals/${referralId}/intermediaries/${uid}`,
                payload: rfq,
                context: 'CreateReferralPage'
            });

            await db.update({
                path: `intermediaries/${uid}/referrals/${referralId}`,
                payload: rfq,
                context: 'CreateReferralPage'
            });

            navigate(`/casework/referral/${referralId}`);

        })();
    }

    return (
        <MemberMiniMenu>
            {
                users && !referrer &&
                <React.Fragment>
                    <Alert variant="filled" severity="info">Use this page to make a new referral from a referrer you know who wants a
                        quote from you. The referral will appear as usual, and you can prepare the quote.
                        If the referrer is not yet set up on TiCiT (ie they don't appear when you search the list below), send a direct message to Paula and Bec
                        with the following information: REFERRER NAME, EMAIL, COMPANY AND
                        INVOICING ADDRESS</Alert>
                    <Spacer />
                    <UserChooser users={users?.filter(({ organization }) => organization !== '0000')} onSelect={handleReferrerSelect} />
                </React.Fragment>
            }
            {
                referrer && organization &&
                <CreateReferralContent referrer={referrer} organization={organization} onSubmit={handleSubmit} />
            }
        </MemberMiniMenu>
    );
};

export default CreateReferralPage;